import { render, staticRenderFns } from "./OrgViewRetired.vue?vue&type=template&id=22b2adb5&scoped=true"
import script from "./OrgViewRetired.vue?vue&type=script&lang=js"
export * from "./OrgViewRetired.vue?vue&type=script&lang=js"
import style0 from "./OrgViewRetired.vue?vue&type=style&index=0&id=22b2adb5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b2adb5",
  null
  
)

export default component.exports